import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import crossGreyIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-grey-icon.svg'
import {CSVBoxButton} from '@csvbox/react'
import {toast} from 'react-toastify'
import {useAuth} from '../../../auth'
import {SwitchViewerModal} from './SwitchViewerModal'
import {useMoveToFolderData} from '../../core/FileToFolderAuth'
import {ToolTipUI} from '../../../widgets/components/UI/ToolTipUI'
import {GET_FILE_URL} from '../../../onboarding/core/_requests'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../../hooks/gtmHelpers'

export const RestrictAccessDrawer = ({formik, aclList, setAclList}: any) => {
  const {currentUser, companyId} = useAuth()
  const [isEmptyEmail, setIsEmptyEmail] = useState(true)
  const {formatMessage} = useIntl()
  const [email, setEmail] = useState('')
  const isAllowAcl = formik.values.aclType === 'ALLOW'
  const [showViewerModal, setViewerShowModal] = useState(false)
  const {restrictAccessDrawer, setRestrictAcessDrawer} = useMoveToFolderData()
  const [, setEmailError] = useState('')
  const fileName = 'demoFile.csv'

  const handleYesButtonClick = () => {
    setViewerShowModal(false)
    setRestrictAcessDrawer(false)
  }
  const isValidEmail = (email: string) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    return emailPattern.test(email)
  }

  const handleAllowClick = () => {
    const emails = email.split(',').map((e) => e.trim())
    let invalidEmails = emails.filter((e) => !isValidEmail(e))

    if (invalidEmails.length) {
      setEmailError(`Invalid emails: ${invalidEmails.join(', ')}`)
      return
    }

    if (emails.length > 0) {
      const updatedAclList = [...aclList, ...emails]

      const uniqueAclList = updatedAclList.filter((item, index, self) => {
        return self.indexOf(item) === index
      })

      setAclList(uniqueAclList)
      setEmail('')
      setIsEmptyEmail(false)
      formik.setFieldValue('aclList', uniqueAclList)
      setEmailError('')
    } else {
      setIsEmptyEmail(true)
    }
  }

  const handleRemoveClick = (indexToRemove: number) => {
    const updatedAclList = aclList.filter((_: any, index: number) => index !== indexToRemove)
    setAclList(updatedAclList)
    formik.setFieldValue('aclList', updatedAclList)
  }

  useEffect(() => {
    setIsEmptyEmail(aclList.length === 0)
  }, [aclList])

  const handleClearListClick = () => {
    setAclList([])
    formik.setFieldValue('aclList', '[]')
    setEmail('')
    setIsEmptyEmail(true)
  }

  const handleImportCSV = (data: any) => {
    if (data) {
      const emailsFromCSV = data.Emails.map((row: any) => row.email)
      const updatedAclList = [...aclList, ...emailsFromCSV]
      setAclList(updatedAclList)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DataRoomImportCSVSuccessful,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
          },
        },
      })
      formik.setFieldValue('aclList', updatedAclList)
    } else {
      toast.error(formatMessage({id: 'File import failed, Please try later'}))
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DataRoomImportCSVFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
          },
        },
      })
    }
  }

  const handleCancelClick = () => {
    formik.setFieldValue('aclType', 'ALLOW')
    setRestrictAcessDrawer(false)
  }

  const downloadDummyCSVFile = async () => {
    try {
      const apiUrl = `${GET_FILE_URL}/${fileName}`
      const response = await fetch(apiUrl)

      if (!response.ok) {
        throw new Error(formatMessage({id: 'Failed to fetch the file'}))
      }

      const blob = await response.blob()
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      a.remove()
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DataRoomDownloadCSVFileSuccessful,
          action: 'normal',
          metadata: {
            file_name: fileName,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
          },
        },
      })
    } catch (error) {
      console.error('Error downloading file:', error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DataRoomDownloadCSVFileFailed,
          action: 'normal',
          metadata: {
            file_name: fileName,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: error,
          },
        },
      })
    }
  }

  return (
    <div
      id='kt_restrict-access'
      className={
        restrictAccessDrawer ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'
      }
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'320px','md': '660px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_restrict-access_toggle'
      data-kt-drawer-close='#kt_restrict-access_close'
    >
      <div className='restrict_access-drawer-wrapper w-100 card shadow-none rounded-0'>
        <div
          className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
          id='kt_restrict-access_header'
        >
          <div className='d-flex flex-row align-items-center   w-100'>
            <button
              type='button'
              className='btn p-0 btn-active-light-primary me-4 '
              onClick={handleCancelClick}
            >
              <img src={crossIcon} alt=''></img>
            </button>

            <div className='d-flex flex-row align-items-center  justify-content-between flex-grow-1 '>
              <h3 className='drawer-head-title  mb-0 me-4 text-dark'>
                {formatMessage({id: 'Restrict Access'})}
              </h3>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'GLOBAL.TOOLTIP.DATAROOM.RESTRICT_ACCESS_DRAWER',
                })}
              />
            </div>
          </div>
        </div>
        <div
          className='restrict_access-drawer-body px-5 pt-3  pt-md-7 px-md-7 pb-md-0 '
          id='kt_restrict-access_body'
        >
          <div
            id='kt_restrict-access_scroll'
            className='w-100 d-flex flex-column  mb-5 mt-2 activity-container-n overflow-visible'
          >
            <p className='access-method-heading text-dark'>
              {formatMessage({id: 'Access Method'})}
            </p>
            <div className='d-flex flex-column flex-md-row align-items-center mb-6 access-method-grid'>
              <div className='form-check  d-flex flex-row mb-md-0 mb-1 btn-bg-white'>
                <input
                  className='form-check-input'
                  type='radio'
                  name='aclType'
                  id='AllowSpeciafiedViewers'
                  value='ALLOW'
                  checked={formik.values.aclType === 'ALLOW'}
                  onChange={formik.handleChange}
                />
                <label
                  className='form-check-label mt-n1 ms-3 text-dark'
                  htmlFor='AllowSpeciafiedViewers'
                >
                  {formatMessage({id: 'Allow Specific Viewers'})} <br></br>{' '}
                  <span>
                    {formatMessage({
                      id: 'Allow specified emails/domains to your content while blocking everyone else.',
                    })}
                  </span>
                </label>
              </div>

              <div className='form-check  d-flex flex-row ms-md-7 mb-0 btn-bg-white'>
                <input
                  className='form-check-input'
                  type='radio'
                  name='aclType'
                  id='BlockSpecificviewers'
                  value='BLOCK'
                  checked={formik.values.aclType === 'BLOCK'}
                  onChange={formik.handleChange}
                />
                <label className='form-check-label mt-n1 ms-3' htmlFor='BlockSpecificviewers'>
                  {formatMessage({id: 'Block Specific Viewers'})} <br></br>{' '}
                  <span>
                    {formatMessage({
                      id: 'Block specified emails/domains from accessing your content while allowing everyone else',
                    })}
                  </span>
                </label>
              </div>
            </div>

            <div className=' email-address-n-domain'>
              <div className='d-flex flex-row align-items-center mb-2'>
                <label htmlFor='exampleInputEmail1' className='form-label me-1 mb-0'>
                  {formatMessage({id: 'Email Address/Domain'})}
                </label>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'GLOBAL.TOOLTIP.DATAROOM.RESTRICT_ACCESS_DRAWER.EMAIL',
                  })}
                />
              </div>

              <div className={'d-flex flex-column flex-md-row '}>
                <input
                  type='email'
                  className='form-control'
                  id='exampleInputEmail1'
                  aria-describedby='emailHelp'
                  placeholder={formatMessage({id: 'hello@acme.com, @acme.com'})}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                />
                <button
                  className='btn btn-light flex-grow-1 text-center mt-md-0 mt-1 flex-md-grow-0 ms-md-3'
                  onClick={handleAllowClick}
                  disabled={!email.trim()}
                >
                  <span>
                    {isAllowAcl ? formatMessage({id: 'Allow'}) : formatMessage({id: 'Block'})}
                  </span>
                </button>
              </div>

              <div className='d-flex justify-content-between'>
                <div id='emailHelp' className='form-text'>
                  {formatMessage({
                    id: 'Add multiple email addresses and or domains and press “Enter”. Alternatively, you can',
                  })}{' '}
                  <CSVBoxButton
                    licenseKey={process.env.REACT_APP_CSVBOX_LICENSE_KEY_EMAIL}
                    user={{
                      user_id: `${currentUser?.userId}`,
                    }}
                    onImport={(result: any, data: any) => {
                      if (result) {
                        const sendData = {
                          Emails: data.rows,
                        }
                        handleImportCSV(sendData)
                      } else {
                        toast.error(formatMessage({id: 'File import failed, Please try later'}))
                      }
                    }}
                    render={(launch: any) => (
                      <div
                        className='csv-file text-primary font-size-13 font-weight-700 height-24  px-3'
                        onClick={launch}
                      >
                        {formatMessage({id: 'import a CSV file directly'})}
                      </div>
                    )}
                  />
                </div>
                <div
                  className='csv-file-dummy text-primary font-size-13 font-weight-700 height-24  px-3 pt-9 text-underline'
                  onClick={downloadDummyCSVFile}
                >
                  {formatMessage({id: 'download dummy csv file'})}
                </div>
              </div>
            </div>
            <div className='mb-3 search-investor-updates-wrapper'>
              <div className='d-flex flex-row align-items-center justify-content-between mb-1'>
                <label htmlFor='exampleInputEmail1' className='form-label  mb-0'>
                  {isAllowAcl
                    ? formatMessage({id: 'Allow List'})
                    : formatMessage({id: 'Block List'})}
                </label>
              </div>
              <div className='position-relative'></div>
              <div className='search-result-list mt-1'>
                {aclList.map((email: any, index: number) => (
                  <div
                    className='d-flex flex-row align-items-center justify-content-between search-result-row'
                    key={index}
                  >
                    <p className='mb-0'>{email}</p>
                    <img
                      className='cursor-pointer'
                      src={crossGreyIcon}
                      alt=''
                      onClick={() => handleRemoveClick(index)}
                    />
                  </div>
                ))}
              </div>
              {isEmptyEmail && (
                <div className='error-message text-danger pt-2'>
                  {formatMessage({id: 'At least 1 email is required.'})}
                </div>
              )}
              <div className='allow-list-action d-flex flex-end'>
                <button
                  type='button'
                  className='btn btn-transparent text-danger flex-grow-1 text-center  flex-md-grow-0  '
                  onClick={handleClearListClick}
                >
                  {formatMessage({id: 'Clear List'})}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* begin::Footer */}
        <div className='restrict_access-drawer-footer d-flex justify-content-end' id='kt_footer'>
          <button
            type='button'
            className='btn btn-light flex-grow-1 flex-md-grow-0'
            onClick={handleCancelClick}
          >
            {formatMessage({id: 'Cancel'})}
          </button>
          <button
            type='button'
            className='btn btn-primary flex-grow-1 flex-md-grow-0'
            onClick={() => {
              setViewerShowModal(true)
            }}
            disabled={isEmptyEmail}
          >
            {formatMessage({id: 'Save'})}
          </button>
        </div>
        <SwitchViewerModal
          showViewerModal={showViewerModal}
          onYesButtonClick={handleYesButtonClick}
          setViewerShowModal={setViewerShowModal}
          headingMessage={isAllowAcl ? 'Switch to allowing viewers' : 'Switch to blocking viewers'}
          description={
            isAllowAcl
              ? 'This change will allow access to the link for the email address and domains listed. You will still need to submit the form to save your changes. Do you want to continue?'
              : 'This change will block access to the link for the email address and domains listed. All other viewers will be allowed. You will still need to submit the form to save your changes. Do you want to continue?'
          }
        />
        {/* end::Footer */}
      </div>
    </div>
  )
}
